import axios from 'axios'
import config from '../config'

function getApiHost() {
  switch(process.env.NODE_ENV) {
    case 'development' : return config.baseURL;
    default : return `${location.protocol}//${location.host.replace(/^[^\\.]*\./, 'api.')}/v1`;
  }
}

const baseUrl = getApiHost();
const http = axios.create({
  baseURL: baseUrl,
  timeout: 10000000,
});

http.defaults.headers.get['Content-Type'] = 'application/json'
http.defaults.headers.post['Content-Type'] = 'application/json'

http.interceptors.response.use((response) => response.data, error => Promise.reject(error.response || { status: 500, data: error.message }));
if(location.hostname == 'localhost') { window['http'] = http; }

const auth = {
  // default
  login: (m) => { return http.post('auth/manager/login', m); },
  profile: (m) => { return http.post('auth/manager/profile/get', m); },
  refresh: () => { return http.get('auth/manager/refresh/' + new Date().getTime()); },
  setAuth: (token) => { http.defaults.headers.common['Authorization'] = 'Bearer ' + token; },
  unsetAuth: () => { delete http.defaults.headers.common['Authorization']; },

  // check otp, changePasswordCycle
  preflight: (m) => { return http.post('auth/manager/preflight', m); },
  checkPasswordCycle: (m) => { return http.post('auth/manager/cycle/password', m); },

  // profile updte
  update: (m) => { return http.post('auth/manager/profile/update', m); },
  ResetPassword : (m) => { return http.post('auth/manager/reset/password', m); },

  // otp
  otpGen : (m) => { return http.post('auth/manager/otp/gen',m); },
  otpVerify : (m) => { return http.post('auth/manager/otp/verify', m); },
  otpRegister : (m) => { return http.post('auth/manager/otp/register', m); },
  otpUnregister : (m) => { return http.post('auth/manager/otp/unregister', m); },

  // token
  tokenReset : (m) => { return http.post('auth/manager/reset/token', m); },
  tokenVerify : (m) => { return http.post('auth/manager/reset/verify', m); },

}
const Billing = (m) => { return http.post(`/billing`, m); }
const Billing_Call = (a, b, c = { ts : new Date().getTime() }) => Billing({ target: a, cmd : b, body: c });
const Manager = (m) => { return http.post(`/manager`, m); }
const Manager_Call = (a, b, c = { ts : new Date().getTime() }) => Manager({ target: a, cmd : b, body: c });

// restful api
const ManagerApi = (m) => { return http.post(`/manager/${m.target}/${m.cmd}`, m); }
const Manager_Call_Api = (a, b, c) => ManagerApi({ target: a, cmd : b, body: c });

export { auth, Manager, Manager_Call, Billing, Billing_Call, ManagerApi, Manager_Call_Api }
